<template v-if="baselTests && basePvItem && baselTestsItems">
  <v-row>
    <v-col
      v-for="(baselTestItem, index) in baselTestsItems"
      :key="baselTestItem.id"
      cols="12"
      md="6"
    >
      <basel-test-block
        v-if="baselTestItem"
        :key="baselTestItem.id"
        :data="baselTestItem"
        :base-item="basePvItem"
        :maturities="maturities"
        :risk-base-currency="riskBaseCurrency"
        :color="colorMapping[index % 4]"
        :subtitle-color="colorMapping[index % 4]"
        :subtitle-size="12"
      />
    </v-col>
  </v-row>
</template>

<script>
import BaselTestBlock from '@/theme/default/views/banking/risk/basel-tests/BaselTestBlock'

export default {
  name      : 'BaselTests',
  components: { BaselTestBlock },
  props     : {
    data: {
      type   : Object,
      default: () => null
    },
    subtitleColor: {
      type   : String,
      default: null
    },
    subtitleSize: {
      type   : String,
      default: null
    }
  },
  data () {
    return {
      colorMapping: [
        'synthesis-ui-green-01',
        'synthesis-ui-orange-01',
        'synthesis-ui-purple-02',
        'synthesis-ui-yellow-02',
        'synthesis-ui-green-01',
        'synthesis-ui-orange-01'
      ]
    }
  },
  computed: {
    riskBaseCurrency () {
      return this.data?.baseCurrency || null
    },
    baselTests () {
      return this.data?.result?.baselTests || null
    },
    basePvItem () {
      return this.baselTests?.basePvItem || null
    },
    baselTestsItems () {
      return this.baselTests?.baselTestsItems || null
    },
    maturities () {
      return this.baselTests?.maturities || null
    }
  }
}
</script>

<style scoped>
</style>
